import { graphql } from "@/gql";

export const createQuoteMutation = graphql(`
  mutation CreateQuote($input: CreateQuoteInput!) {
    createQuote(input: $input) {
      id
      reference
    }
  }
`);

export const updateQuoteMutation = graphql(`
  mutation UpdateQuote($id: ID!, $input: UpdateQuoteInput!) {
    updateQuote(id: $id, input: $input) {
      id
    }
  }
`);

export const createQuotePdfMutation = graphql(`
  mutation CreateQuotePdf($id: ID!) {
    createQuotePdf(id: $id)
  }
`);

export const issueQuoteMutation = graphql(`
  mutation IssueQuote($id: ID!) {
    issueQuote(id: $id) {
      id
      reference
    }
  }
`);

export const acceptQuoteMutation = graphql(`
  mutation AcceptQuote($id: ID!, $purchase_order_number: String) {
    acceptQuote(id: $id, purchase_order_number: $purchase_order_number) {
      id
      purchase_order_number
    }
  }
`);

export const rejectQuoteMutation = graphql(`
  mutation DeclineQuote(
    $id: ID!
    $reason: QuoteDeclinedReason
    $description: String
  ) {
    declineQuote(id: $id, reason: $reason, description: $description) {
      id
    }
  }
`);

export const invoiceQuoteMutation = graphql(`
  mutation InvoiceQuote($quoteId: ID!) {
    invoiceQuote(quoteId: $quoteId) {
      id
    }
  }
`);

export const sendQuoteMutation = graphql(`
  mutation SendQuote($id: ID!, $email: String) {
    sendQuote(id: $id, email: $email) {
      id
    }
  }
`);
